import {Component, OnInit, ViewChild} from '@angular/core';
import {DataService} from '../../../Services/data.service';
import {HttpErrorResponse} from '@angular/common/http';
import {NotificationService} from '../../../Services/notification.service';
import {UntypedFormBuilder} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {NavigationService} from '../../../Services/navigation.service';
import {EntityDetailComponent} from '../resources/entity-detail/entity-detail.component';
import {ConfirmDialogService} from '../../../Services/confirm-dialog.service';
import {Title} from '@angular/platform-browser';


@Component({
  selector: 'app-entity-form',
  templateUrl: './entity-form.component.html',
  styleUrls: ['./entity-form.component.css'],
  standalone: false
})
export class EntityFormComponent implements OnInit {

  entityId = '';
  AllEntities = false;
  ReceivableAging = false;


  showNameAddress = false;
  showHistory = false;
  showActivityFeed = false;
  history: [];

  // Data Objects
  Entity;
  Location;

  Term;
  TaxList;
  entityType;
  entityAddress;
  entityContact;
  auditTrail;
  receivable = 100;
  payable = 0;

// button stuff
  stopEdit = true;
  buttonsDisabled = false;
  buttonConfig: any = {
    save: true,
    close: true,
    reset: true,
    delete: true,
    saveNew: true,
    saveClose: true,
    print: false,
  };

  constructor(
    private table: DataService,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private nav: NavigationService,
    private confirmDialogService: ConfirmDialogService,
    private notification: NotificationService,
    private titleService: Title) {
    this.entityId = this.route.snapshot.params.id;
  }

  @ViewChild(EntityDetailComponent, {static: false}) EntityDetail: EntityDetailComponent;

  ngOnInit() {
    this.titleService.setTitle($localize`:Entity@@entity:Entity`);
    this.showNameAddressClick();
    if (this.entityId) {
      this.buttonConfig.reset = false;
      this.stopEdit = false;
    }
    // this.isThisUsed(this.entityId, 'entity_id', 't_header');
  }

  deleteItem(): void {
    let retMsg = '';
    const messages: string[] = [$localize`:Are you sure you want to delete Entity? @@areYouSureYouWantToDeleteEntity:Are you sure you want to delete Entity?`, this.entityId];
    this.confirmDialogService.confirmThis(messages,
      () => {
        this.table.deleteDataById('entity', this.entityId).subscribe(
          result => {
            retMsg = result;
            // this.notification.success($localize`:Deleted @@deleted:Deleted`);
          },
          (error: HttpErrorResponse) => {
            // this.notification.error($localize`:Error @@error:Error`);
            console.log(error);
          },
          () => {
            this.close();
          });
      }, () => {
        this.notification.success($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
      });
  }


  showNameAddressClick() {
    this.AllFalse();
    this.showNameAddress = true;
  }

  showHistoryClick() {
    this.AllFalse();
    // vm.getHistory()
    this.showHistory = true;
  }

  showActivityClick() {
    // vm.getActivityFeed()
    this.AllFalse();
    this.showActivityFeed = true;
  }

  AllFalse() {
    this.showNameAddress = false;
    this.showHistory = false;
    this.showActivityFeed = false;
  }


  save(saveClose: boolean = false) {
    return this.EntityDetail.onSave(saveClose);
  }

  saveNew() {
    // Only clear the form after async save succeeds inside the child component
    if (this.EntityDetail) {
      (this.EntityDetail as any).isSaveNew = true;
    }
    this.save(false);
  }

  async saveClose() {
    if (this.save(true)) {
      this.close();
    }
  }

  close() {
    this.nav.backOr('entity-list');
  }
}
